import { useQuery } from "react-query";
import { getFigureflowInterface } from "../../../services/figureflow";

export const useGetFigureflowInterface = () => {
  return useQuery(
    ["getFigureflowInterface"],
    () => getFigureflowInterface().then((res) => res?.data?.data),
    { staleTime: Infinity },
  );
};
